export const productReviewsReducer = (state={product:{}},action) => {
    switch(action.type){
        case "GET_PRODUCT_REVIEW":
            return{
                ...state,
                reviews: action.payload
            }
        case "ADD_REVIEW":
            return {
        ...state,
        reviews: [...state.reviews, action.payload],
      };
        default: 
        return state
    }
    }